module.exports = __webpack_public_path__ + "static/img/dummy_burger_thumb_001.ea41e18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/burger/dummy_burger_thumb_001.png
// module id = /LMN
// module chunks = 1